export class AttributeHelper{

    /**@type {HTMLElement} */
    target = null;

    #numberScaling = 1;

    /**
     * 
     * @param {HTMLElement} target 
     * @param {number} scale
     */
    constructor( target, scale = 1){ 
        this.target = target;
        this.#numberScaling = scale; 
    }

    enumFromAttribute( attrName, enumObject, defaultValue = null ){
        if(this.target.hasAttribute(attrName)){
            const value = this.target.getAttribute(attrName);
            const result = AttributeHelper.fromValue(value, enumObject);
            if(result !== null) return result;
        }
        return defaultValue;
    }

    numberFromAttribute( attrName, defaultValue = 0 ){
        if(this.target.hasAttribute(attrName)){
            const value = this.target.getAttribute(attrName);
            const numberValue = Number(value);
            if(!isNaN(numberValue) || numberValue === 0) return numberValue ;
        } 
        return defaultValue;
    }

    /**
     * This function will return the value of the enum object, if the value is passed in the function it will check if the value is in the enum object and return the value of the enum object, 
     * if the value is not found it will return null.
     * if a number is passed in, it can be the index of the enum object or the value.
     * if a string is passed in, it can be the key of the enum object or the value.
     * @param {string|number} valueKeyOrIndex 
     * @param {object} enumObject 
     * @returns {string|number|null} returns the value of the enum object or null if not found
     */
    static fromValue( valueKeyOrIndex, enumObject ){
        const entries = Object.entries(enumObject);
        const numValue = Number(valueKeyOrIndex);

        if( !isNaN(numValue) ){
            if(entries.every( v => typeof(v[1]) === "number" )){
                const find = entries.find( v => v[1] === numValue );
                if(find) return find[1];
            }else if( numValue <= entries.length){
                return entries[numValue][1];
            }
        }else if(typeof(valueKeyOrIndex) === "string"){
            const lowerValue = valueKeyOrIndex.toLocaleLowerCase();
            const findValue = entries.find( v => v[1].toLocaleLowerCase() === lowerValue );
            const findKey = entries.find( v => v[0].toLocaleLowerCase() === lowerValue );
            return findValue ? findValue[1] : findKey ? findKey[1] : null;
        }
        return null;
    }


}